module.exports = __webpack_public_path__ + "img/moon-01.3c21e3b0.svg";